import { useMutation } from '@tanstack/react-query';
import React, { useState } from 'react';
import { View } from 'react-native';
import { MysteryShopperClient } from '../../../../api/api.g';
import useApi from '../../../../hooks/api-hook';
import { useAppSelector } from '../../../../hooks/store-hook';
import useTranslation from '../../../../hooks/translation-hook';
import { UserPrefsHelper } from '../../../../models/helpers/userPrefsHelper';
import CustomTextInput, { ValidationResult } from '../../../common/CustomTextInput';
import Label from '../../../common/Label';
import ProfileModal from '../ProfileModal';
import Popup from '../../../common/Popup';
import useUserPrefsService from '../../../../hooks/userPrefsService-hook';

const PROFILE_NAME_MAX_LENGTH = 100;

const NamePopup = (props) => {
  const t = useTranslation();
  const userPrefs = useAppSelector((selector) => selector.userPrefs);
  const userPrefService = useUserPrefsService();
  const apiMysteryShopper = useApi(MysteryShopperClient);
  const [userPrefsValue, setUserPrefsValue] = useState(userPrefs);
  const [validation, setValidation] = useState<ValidationResult>();
  const [validation2, setValidation2] = useState<ValidationResult>();
  const [forceValidation, setForceValidation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const saveBasicMutation = useMutation({
    mutationFn: () => {
      const data = UserPrefsHelper.mapToSaveBasicInformationDto(userPrefsValue);
      return apiMysteryShopper.saveBasicInformation(data).then(() => {
        userPrefService.updateUserProfileInfo((userPrefs) => {
          setIsLoading(false);
          props.onClose && props.onClose();
          props.onConfirm && props.onConfirm(userPrefs);
        });
      });
    },
  });

  const handleOnConfirm = () => {
    const firstNameWithinLimit = (userPrefsValue.firstName?.trim().length ?? 0) <= PROFILE_NAME_MAX_LENGTH;
    const lastNameWithinLimit = (userPrefsValue.lastName?.trim().length ?? 0) <= PROFILE_NAME_MAX_LENGTH;

    if (userPrefsValue.lastName && userPrefsValue.firstName && firstNameWithinLimit && lastNameWithinLimit) {
      saveBasicMutation.mutate();
    } else {
      setForceValidation(true);
    }
  };

  return (
    <Popup loading={isLoading} suspendDrawer={props.suspendDrawer}>
      <ProfileModal
        title={t('My-informations')}
        subtitle={t('it_would_be_more_friendly_to_know_your_name')}
        height={props.height}
        pageNumber={props.currentPage}
        maxPageNumber={props.maxPage}
        onClose={() => {
          props.onClose && props.onClose();
        }}
        onConfirm={() => {
          handleOnConfirm();
        }}
      >
        <View>
          <Label style={{ marginBottom: 8 }}>{t('first_name')}</Label>
          <CustomTextInput
            required
            forceValidation={forceValidation}
            validateOnBlur
            showErrorMessage
            hasError={validation?.valid === false}
            errorMessage={validation?.valid === false ? validation.message : undefined}
            placeholder=""
            value={userPrefs.firstName}
            maxLength={PROFILE_NAME_MAX_LENGTH}
            onChangeText={(t) =>
              setUserPrefsValue((current) => {
                return { ...current, firstName: t };
              })
            }
            onValidationChange={(validation) => {
              setForceValidation(false);
              setValidation(validation);
            }}
          />
          <Label style={{ marginTop: 16, marginBottom: 8 }}>{t('last_name')}</Label>
          <CustomTextInput
            forceValidation={forceValidation}
            required
            validateOnBlur
            showErrorMessage
            hasError={validation2?.valid === false}
            errorMessage={validation2?.valid === false ? validation2.message : undefined}
            placeholder=""
            value={userPrefs.lastName}
            maxLength={PROFILE_NAME_MAX_LENGTH}
            onChangeText={(t) =>
              setUserPrefsValue((current) => {
                return { ...current, lastName: t };
              })
            }
            onValidationChange={(validation) => {
              setForceValidation(false);
              setValidation2(validation);
            }}
          />
        </View>
      </ProfileModal>
    </Popup>
  );
};

export default NamePopup;
